export default "__VITE_ASSET__lnloGAdr__"